module.exports = "/_next/static/images/AIAndML-sm@2x-a957ca3ac5803262a3ffc43bf01364a5.png";